"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    activeSheet: {
        type: String,
        default: undefined
    },
    columnWidth: {
        type: Number,
        default: undefined
    },
    columns: {
        type: Number,
        default: undefined
    },
    defaultCellStyle: {
        type: Object,
        default: undefined
    },
    headerHeight: {
        type: Number,
        default: undefined
    },
    headerWidth: {
        type: Number,
        default: undefined
    },
    excel: {
        type: Object,
        default: undefined
    },
    pdf: {
        type: Object,
        default: undefined
    },
    rowHeight: {
        type: Number,
        default: undefined
    },
    rows: {
        type: Number,
        default: undefined
    },
    sheets: {
        type: Array,
        default: undefined
    },
    sheetsbar: {
        type: Boolean,
        default: undefined
    },
    toolbar: {
        type: [Boolean, Object],
        default: undefined
    },
    useCultureDecimals: {
        type: Boolean,
        default: undefined
    },

    // Events
    insertSheet: {
        type: Function,
        default: undefined
    },
    removeSheet: {
        type: Function,
        default: undefined
    },
    renameSheet: {
        type: Function,
        default: undefined
    },
    selectSheet: {
        type: Function,
        default: undefined
    },
    unhideColumn: {
        type: Function,
        default: undefined
    },
    unhideRow: {
        type: Function,
        default: undefined
    },
    hideColumn: {
        type: Function,
        default: undefined
    },
    hideRow: {
        type: Function,
        default: undefined
    },
    deleteColumn: {
        type: Function,
        default: undefined
    },
    deleteRow: {
        type: Function,
        default: undefined
    },
    insertColumn: {
        type: Function,
        default: undefined
    },
    insertRow: {
        type: Function,
        default: undefined
    },
    select: {
        type: Function,
        default: undefined
    },
    changeFormat: {
        type: Function,
        default: undefined
    },
    changing: {
        type: Function,
        default: undefined
    },
    change: {
        type: Function,
        default: undefined
    },
    render: {
        type: Function,
        default: undefined
    },
    excelExport: {
        type: Function,
        default: undefined
    },
    excelImport: {
        type: Function,
        default: undefined
    },
    pdfExport: {
        type: Function,
        default: undefined
    },
    copy: {
        type: Function,
        default: undefined
    },
    cut: {
        type: Function,
        default: undefined
    },
    paste: {
        type: Function,
        default: undefined
    },
    dataBinding: {
        type: Function,
        default: undefined
    },
    dataBound: Function
};